<template>
  <div>
    <el-tabs v-model="goodsInfoActiveTab" type="card">
      <el-tab-pane :label="$t('SourcingDetails.form.Summarize')" name="sku">
        <SkuList
          v-if="goodsInfoActiveTabHistory.has('sku')"
          :order-id="orderId"
          :has-btn="hasBtn"
        />
      </el-tab-pane>
      <el-tab-pane :label="$t('SourcingDetails.form.line')" name="skuItem">
        <SkuLineList
          v-if="goodsInfoActiveTabHistory.has('skuItem')"
          :order-id="orderId"
          :has-btn="hasBtn"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import SkuList from './SkuList';
import SkuLineList from './SkuLineList';
export default {
  name: 'BusinessOrderPreemptDetailGoodsInfoTab',
  components: { SkuList, SkuLineList },
  props: {
    orderId: {
      type: String,
      default: null,
    },
    objectVersionNumber: {
      type: Number,
      default: null,
    },
    hasBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      goodsInfoActiveTab: 'sku',
      goodsInfoActiveTabHistory: new Set(['sku']),
    };
  },
  watch: {
    goodsInfoActiveTab(v) {
      this.goodsInfoActiveTabHistory.add(v);
    },
    // orderId变化时，重新渲染LIST
    orderId(v) {
      const temp = this.goodsInfoActiveTabHistory;
      this.goodsInfoActiveTabHistory = new Set();
      this.$nextTick(e => {
        this.goodsInfoActiveTabHistory = temp;
      });
    },
  },
  methods: {},
};
</script>
